
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.86663 10.0333V15.1667C4.86663 15.5717 5.19496 15.9 5.59997 15.9H14.4C14.805 15.9 15.1333 15.5717 15.1333 15.1667V10.0333M4.86663 10.0333H15.1333M4.86663 10.0333C4.46163 10.0333 4.1333 9.70504 4.1333 9.30002V7.83335C4.1333 7.42834 4.46163 7.10002 4.86663 7.10002H15.1333C15.5383 7.10002 15.8666 7.42834 15.8666 7.83335V9.30002C15.8666 9.70504 15.5383 10.0333 15.1333 10.0333M9.99997 7.10002V5.87779M9.99997 7.10002H8.77772C7.42771 7.10002 6.3333 6.0056 6.3333 4.65557C6.3333 3.98056 6.88051 3.43335 7.55553 3.43335C8.90554 3.43335 9.99997 4.52776 9.99997 5.87779M9.99997 7.10002H11.2222C12.5722 7.10002 13.6666 6.0056 13.6666 4.65557C13.6666 3.98056 13.1194 3.43335 12.4444 3.43335C11.0944 3.43335 9.99997 4.52776 9.99997 5.87779M9.99997 7.10002V15.9"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
<script>
export default {
  name: 'GiftIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
<style scoped>
</style>
